import { render, staticRenderFns } from "./PhysicalResults.vue?vue&type=template&id=7537dceb&scoped=true"
import script from "./PhysicalResults.vue?vue&type=script&lang=js"
export * from "./PhysicalResults.vue?vue&type=script&lang=js"
import style0 from "./PhysicalResults.vue?vue&type=style&index=0&id=7537dceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7537dceb",
  null
  
)

export default component.exports